import React, { useState, useEffect } from 'react';

import Primarytheme from './utility/theme';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import CloseIcon from '@mui/icons-material/Close';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableVirtuoso } from 'react-virtuoso';

import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Snackbar } from '@mui/material';

import { styled } from '@mui/material/styles';
import { Grid, Typography, Stack, Checkbox, FormControlLabel, FormGroup, Button, Chip } from '@mui/material';

import ProjectDisable from './utility/ProjectDisable';
import ProjectParameters from './utility/ProjectParameters';

import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import * as FileSaver from 'file-saver'

import { getSessionIdToken } from './auth/apiAuth'

import axios from 'axios';

const { buildUsernameFromEmail } = require('./auth/utils-auth');


const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'left',
    color: Primarytheme.palette.primary.main,
    fontSize: '16px',
    fontWeight: 'bold',
    background: 'white',
    boxShadow: '0px 0px 0px 0px, 1px 1px 5px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%)',
    border: '1px',
    minWidth: 950
}));


const {
    REACT_APP_USER_ID,
    REACT_APP_USER_POOL_ID,
} = process.env;

export default function Billing({ auth }) {
    const colors = [
        '#4287f5',
        '#f5c842',
        '#f5ac6c',
        '#42dbb5',
        '#c70a0a',
        '#006f89',
        '#e32282',
        '#656565',
        '#0d1aa3',
        '#c4db5a',
        '#fc6c00',
        '#1d802f',
        '#ff8585',
        '#009974',
        '#820000',
        '#ccbd00',
        '#58006d',
        '#80ccff',
        '#689e00',
        '#82532f',
        '#bf00ed',
        '#994900',
        '#ffe969',
        '#874d5f',
        '#c4c4c4',
        '#b086f2',
        '#243f00',
        '#ffaee6',
        '#8c7228',
        '#303030',



    ]
    const monthLabel = {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
    }

    const [projects, setProjects] = useState({ list: [], labelsProjectsList: [], retrieving: true, apiProjectMap: {} });
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(undefined);
    const MAX_MONTHS = 24;
    const [monthsRange, setMonthsRange] = useState(12);
    const [excludeInternalTest, setExcludeInternalTest] = useState(false);
    const [fetchingData, setFetchingData] = useState(false);
    const [rawItems, setRawItems] = useState([]);
    const [plotData, setPlotData] = useState([]);
    const [plotDataBar, setPlotDataBar] = useState([]);

    const [tableData, setTableData] = useState([]);
    const [attachedUsers, setAttachedUsers] = useState([]);
    const [fetchingUsers, setFetchingUsers] = useState(false);

    const [userMngmt, setUserMngmt] = useState({
        email: '',
        customer: '',
        isAdmin: false,
        policy: {
            canDelete: true,
            canLaunch: true,
            canManageAsset: true
        },
        //attached_project_ids: [],
        isCreating: false,
        created: false,
        selectedList: [],
        customMessage: ''
    })

    const [patchUsrMngmt, setPatchUsrMngmt] = useState({
        email: '',
        customer: '',
        attached_projects: [],
        selectedList: [],
        isAdmin: false,
        type: '',
        policy: {
            canDelete: false,
            canLaunch: false,
            canManageAsset: false
        },
        registrationDate: undefined,
        lastLogin: undefined,
        isFetching: false,
        fetched: false,
        isPatching: false,
        patched: false,
        openDelete: false,
        customMessage: ''
    })

    const [customerFilter, setCustomerFilter] = useState({
        customer: auth.userState.isAdmin ? 'pagination' : '', // filtro qui di default a pagination, ma anche nell'autocomplete è default a quel valore
        isFetching: false,
        fetched: false,
        users: []
    })

    const [snack, setSnack] = useState({
        open: false,
        creationMessage: ''
    })

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnack({
            open: false,
            creationMessage: ''
        });
    };

    const handleCustomerFilter = (event, value, reason) => {
        if (reason === 'clear') handleResetCustomerPatch();
        else {
            setCustomerFilter({ ...customerFilter, customer: value, users: [] })
            handleResetUserPatch()
        }
    }
    const handleResetCustomerPatch = () => {
        setCustomerFilter({
            customer: '',
            isFetching: false,
            fetched: false,
            users: []
        })
        handleResetUserPatch()
    }
    const handleSelectPathEmail = (event, value, reason) => {
        if (reason === 'clear') handleResetUserPatch()
        else {
            setPatchUsrMngmt({
                ...patchUsrMngmt, email: value.email, retrieving: true
            })
            getUserInfo(value.email)
                .then(response => {
                    //console.log(response.data);
                    const userData = response.data;
                    setPatchUsrMngmt({
                        ...patchUsrMngmt,
                        retrieving: false,
                        email: value.email,
                        selectedList: userData.attached_projects,
                        fetched: true,
                        attached_projects: userData.attached_projects,
                        isAdmin: userData.type === 'administrator',
                        type: userData.type,
                        policy: userData.policy ? userData.policy : { canDelete: true, canLaunch: true, canManageAsset: true },
                        registrationDate: userData.registrationDate ? (new Date(userData.registrationDate)).toUTCString() : 'unknown',
                        lastLogin: userData.lastLogin ? (new Date(userData.lastLogin)).toUTCString() : 'unknown',
                        customMessage: userData.custom_message || '',
                    });
                    setProjects({ ...projects, retrieving: false })
                    //console.log(userData)
                    return userData
                })
                .catch(err => {
                    //console.log(err)
                    setSnack({ open: true, creationMessage: 'fetch user error. Check dynamo.' })
                    setPatchUsrMngmt({ ...patchUsrMngmt, fetched: false });
                })
        }
    }
    const handleSelectedProject = (event, values, reason) => {
        if (reason === 'clear') {
            setSelectedProjects([]);
            setPlotDataBar([]);
            setPlotData([]);
            setTableData([]);
            setRawItems([]);
        }
        if (reason === 'selectOption') setSelectedProjects([...values]);
        if (reason === 'removeOption') {
            setSelectedProjects([...values]);
            setPlotDataBar([]);
            setPlotData([]);
            setTableData([]);
            setRawItems([]);
        }
    }

    const handleSelectedCustomer = (event, value, reason) => {
        setUserMngmt({ ...userMngmt, customer: value })
        if (reason === 'clear') {
            setSelectedCustomer(undefined);
            setSelectedProjects([]);
            setPlotDataBar([]);
            setPlotData([]);
            setTableData([]);
            setRawItems([]);
        }
        if (reason === 'selectOption') {
            if (selectedCustomer !== undefined) setSelectedProjects([]);
            else setSelectedCustomer(value);
        }
        if (reason === 'removeOption') {
            setSelectedCustomer(value)
            setPlotDataBar([]);
            setPlotData([]);
            setTableData([]);
            setRawItems([]);
        }
    }

    const recompute = (items, projects, exclude, months) => {
        const freshPlotData = [];
        for (let t = MAX_MONTHS; t >= 0; t--) {
            let date = new Date();
            date.setMonth(date.getMonth() - t);
            freshPlotData.push({ name: monthLabel[date.getMonth() + 1] + ' ' + date.getFullYear() });
        }

        const currentDataTable = [];
        for (const item of items) {
            if (exclude && item.internalTest) continue;

            const startMonth = new Date(item.startTime).getMonth() + 1;
            const startYear = new Date(item.startTime).getFullYear();
            const projectId = item.project_id.split('/')[1];
            const key = monthLabel[startMonth] + ' ' + startYear;

            const idx = freshPlotData.findIndex(m => m.name === key);
            if (idx !== -1) {
                freshPlotData[idx][projectId] = (freshPlotData[idx][projectId] || 0) + 1;
            }

            currentDataTable.push({
                id: item.reqId,
                projectId: item.project_id,
                date: (new Date(item.startTime)).toLocaleString().replace(/T/, ' ').replace(/\..+/, ''),
                user: item.owner && typeof(item.owner) === 'object' ? item.owner.email : item.owner,
                deleted: item.deleted ? 'Yes' : 'No',
                internalTest: item.internalTest ? 'Yes' : 'No',
                dateEpoch: item.startTime,
            });
        }

        currentDataTable.sort((a, b) => b.dateEpoch - a.dateEpoch);
        const sliced = freshPlotData.slice(freshPlotData.length - (months + 1));
        setPlotData([...sliced]);
        setPlotDataBar(projects);
        setTableData(currentDataTable);
    };

    const fetchLabelsRenders = async (projectId, token) => {
        const items = [];
        let nextToken = null;
        const cutoff = new Date();
        cutoff.setMonth(cutoff.getMonth() - MAX_MONTHS);
        cutoff.setDate(1);
        cutoff.setHours(0, 0, 0, 0);

        do {
            const params = { limit: 200, project_id: projectId };
            if (nextToken) params.next_token = nextToken;
            const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/labels/renders`, {
                headers: { Authorization: token },
                params
            });
            for (const r of (data.renders || [])) {
                if (new Date(r.created_at) < cutoff) return items;
                items.push({
                    reqId: r.render_id,
                    project_id: projectId,
                    startTime: new Date(r.created_at).getTime(),
                    owner: r.requested_by || '',
                    deleted: false,
                    internalTest: false,
                });
            }
            nextToken = data.has_more ? data.next_token : null;
        } while (nextToken);

        return items;
    };

    const showPlot = (async (event, value) => {
        console.log('fetching pagination processes');
        setFetchingData(true);
        const promises = [];
        const token = await getSessionIdToken()

        if (selectedProjects.length > 0) {
            const allItems = [];
            const labelsSet = new Set(projects.labelsProjectsList || []);

            for (const selectedProject of selectedProjects) {
                if (labelsSet.has(selectedProject)) {
                    try {
                        const labelsItems = await fetchLabelsRenders(selectedProject, token);
                        allItems.push(...labelsItems);
                    } catch (err) {
                        console.error('Error fetching labels renders for');
                    }
                } else {
                    const realProjectId = projects.apiProjectMap[selectedProject] || selectedProject;
                    for (let t = 0; t <= MAX_MONTHS; t++) {
                        let dateend;
                        let datestart;
                        let today = new Date();
                        if (t !== 0) {
                            let previousMonth = new Date(new Date().setMonth(today.getMonth() - t))
                            datestart = new Date(new Date(previousMonth.setDate(1)).setHours(0, 0, 0, 0));
                            dateend = new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0)
                        } else {
                            dateend = new Date();
                            datestart = new Date(new Date(new Date().setDate(1)).setHours(0, 0, 0, 0));
                        }
                        promises.push(
                            axios({
                                method: "get",
                                url: `${process.env.REACT_APP_API_BASE_URL}/operations`,
                                headers: {
                                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                                    "content-type": "application/json",
                                    "Authorization": token,
                                    "is_admin": 'true',
                                    "project_id": realProjectId,
                                    "datestart": datestart.getTime(),
                                    "dateend": dateend.getTime(),
                                    "stati": 'tutti',
                                    "show_deleted": 'true'
                                }
                            })
                                .then(resp => {
                                    allItems.push(...resp.data.items);
                                })
                                .catch(err => {
                                    console.error('Error showing plot')
                                })
                        );

                        await Promise.all(promises);
                    }
                }
            }

            setRawItems(allItems);
            recompute(allItems, selectedProjects, excludeInternalTest, monthsRange);
        }

        setFetchingData(false);
    });


    const handleProjectCustomMessage = (event, values) => {
        setPatchUsrMngmt({ ...patchUsrMngmt, customMessage: event.target.value });
    }

    const handleResetUserPatch = () => {
        setPatchUsrMngmt({
            email: '',
            attached_projects: [],
            selectedList: [],
            isAdmin: false,
            type: '',
            registrationDate: undefined,
            lastLogin: undefined,
            policy: {
                canDelete: false,
                canLaunch: false,
                canManageAsset: false
            },
            isFetching: false,
            fetched: false,
            isPatching: false,
            patched: false,
            openDelete: false,
            customMessage: ''
        })
    }

    const retrieveAllProjects = async () => {
        const token = await getSessionIdToken();
        const headers = {
            'user_id': auth.userState.user,
            "content-type": "application/json",
            "Authorization": token,
        };

        const webappPromise = axios.get(`${process.env.REACT_APP_API_BASE_URL}/projects-webapp`, {
            headers: { ...headers, "type": 'project-list' }
        });

        const apiPromise = axios.get(`${process.env.REACT_APP_API_BASE_URL}/projects-webapp`, {
            headers: { ...headers, "type": 'api-project-list' }
        });

        Promise.all([webappPromise, apiPromise.catch(() => ({ data: { projectsList: [] } }))])
            .then(([webappResp, apiResp]) => {
                const webappRaw = webappResp.data.projectsList || [];
                const webappProjects = webappRaw.map(el => `${el.customer}/${el.project_name}`);
                const labelsProjectsList = webappRaw.filter(el => el.is_labels).map(el => `${el.customer}/${el.project_name}`);
                const apiProjectMap = {};
                const apiProjectUsers = {};
                const apiProjects = (apiResp.data.projectsList || []).map(el => {
                    const displayId = `${el.project_class.split('/')[0]}/${el.project_id}`;
                    apiProjectMap[displayId] = el.project_id;
                    if (el.attached_user) {
                        apiProjectUsers[displayId] = el.attached_user;
                    }
                    return displayId;
                });
                const allProjects = [...new Set([...webappProjects, ...apiProjects])].sort();
                setProjects({ list: allProjects, retrieving: false, apiProjectMap, apiProjectUsers, labelsProjectsList });
            })
            .catch(err => {
                console.error('Error fetching projects')
                setProjects({ ...projects, retrieving: false });
            })
    }

    const fetchCustomerUsers = async () => {
        setCustomerFilter({ ...customerFilter, isFetching: true });
        return axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`,
            {
                headers: {
                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),

                    "customer": customerFilter.customer,
                    "action": 'fetch-customer'
                }

            })
            .then(response => {
                const users = response.data.users;
                setCustomerFilter({
                    ...customerFilter,
                    //selectedList: userData.attached_projects,
                    isFetching: false,
                    fetched: true,
                    users: users,

                });
                //console.log(userData)
                return users
            })
            .catch(err => {
                //console.log(err)
                setSnack({ open: true, creationMessage: 'fetch user error. Check dynamo.' })
                setCustomerFilter({ ...customerFilter, fetched: false, isFetching: false });
            })

    }
    const getUserInfo = async (email) => {
        return axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`,
            {
                headers: {
                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),
                    "userInfo_id": buildUsernameFromEmail(email), // lo user id è l'email con la chiocciola sostituita dal punto. per i primi utenti è solo la parte prima della chiocchiola
                    "email": email
                }

            })
    }

    const fetchAttachedUsers = async (customer, projectList) => {
        if (!customer || projectList.length === 0) {
            setAttachedUsers([]);
            return;
        }
        setFetchingUsers(true);
        const token = await getSessionIdToken();
        try {
            const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`, {
                headers: {
                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "Authorization": token,
                    "customer": customer,
                    "action": 'fetch-customer'
                }
            });
            const users = resp.data.users || [];
            const userDetails = await Promise.all(users.map(u =>
                axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`, {
                    headers: {
                        'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                        "content-type": "application/json",
                        "Authorization": token,
                        "userInfo_id": buildUsernameFromEmail(u.email),
                        "email": u.email
                    }
                }).then(r => r.data).catch(() => null)
            ));
            const filtered = userDetails
                .filter(u => u && (
                    (u.attached_projects || []).some(p => projectList.includes(p)) ||
                    (u.attached_labels_projects || []).some(p => projectList.includes(p))
                ))
                .map(u => ({
                    email: u.email,
                    lastLogin: u.lastLogin ? new Date(u.lastLogin).toLocaleString() : 'Never',
                    projects: [...(u.attached_projects || []), ...(u.attached_labels_projects || [])].filter(p => projectList.includes(p))
                }));

            const emailSet = new Set(filtered.map(u => u.email));
            if (projects.apiProjectUsers) {
                for (const displayId of projectList) {
                    const apiUser = projects.apiProjectUsers[displayId];
                    if (apiUser && !emailSet.has(apiUser)) {
                        emailSet.add(apiUser);
                        filtered.push({
                            email: apiUser,
                            lastLogin: '-',
                            projects: [displayId]
                        });
                    } else if (apiUser && emailSet.has(apiUser)) {
                        const existing = filtered.find(u => u.email === apiUser);
                        if (existing && !existing.projects.includes(displayId)) {
                            existing.projects.push(displayId);
                        }
                    }
                }
            }

            setAttachedUsers(filtered);
        } catch (err) {
            console.error('Error fetching attached users');
            setAttachedUsers([]);
        }
        setFetchingUsers(false);
    };

    const patchUserMessage = async (action = 'patch') => {
        setPatchUsrMngmt({ ...patchUsrMngmt, isPatching: true });

        axios.patch(`${process.env.REACT_APP_API_BASE_URL}/users`,
            {
                userInfo_id: buildUsernameFromEmail(patchUsrMngmt.email),
                project_ids: patchUsrMngmt.selectedList,
                type: patchUsrMngmt.type,
                custom_message: patchUsrMngmt.customMessage ? patchUsrMngmt.customMessage : "",
                action,
                user_pool_id: REACT_APP_USER_POOL_ID || auth.userState.ssmParams.USER_POOL_ID
            },
            {
                headers: {
                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),
                }
            })
            .then(() => {
                if (patchUsrMngmt.email === auth.userState.email) {
                    auth.setUserState({ ...auth.userState, customMessage: patchUsrMngmt.customMessage })
                }
                if (patchUsrMngmt.customMessage) setSnack({ open: true, creationMessage: 'updated message for ' + patchUsrMngmt.email })
                else setSnack({ open: true, creationMessage: 'cleared message for ' + patchUsrMngmt.email })
            })
            .catch(err => {
                console.error('Error patching user')
                setSnack({ open: true, creationMessage: JSON.stringify(err) })
            })
            .finally(() => {
                handleResetUserPatch()
            })
    }

    useEffect(() => {
        if (rawItems.length === 0) return;
        recompute(rawItems, plotDataBar, excludeInternalTest, monthsRange);
    }, [monthsRange, excludeInternalTest]);

    useEffect(() => {
        retrieveAllProjects();
    }, []);

    useEffect(() => {
        if (selectedProjects.length > 0) {
            const customer = selectedProjects[0].split('/')[0];
            fetchAttachedUsers(customer, selectedProjects);
        } else {
            setAttachedUsers([]);
        }
    }, [selectedProjects]);


    return (
        <div>
            <Grid
                container
                flexDirection={'row'}
                sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    marginTop: '2em',
                    marginBottom: '2em',
                    marginLeft: '2em',
                    marginRight: '2em'
                }}
                rowSpacing={3}
                columnSpacing={3}
                columns={12}
            >

                <Grid size={{ xs: 12, md: 12 }}>
                    <Item key='project-countChart' >
                        <Typography variant='h5' sx={{ marginBottom: '1em' }} >
                            <b>Project Info Chart</b>
                        </Typography>
                        <Stack direction='row' spacing={2} >
                            <Autocomplete
                                disabled={projects.list.length === 0}
                                limitTags={1}
                                options={Array.from(new Set(projects.list.map(p => p.split('/').shift()))).sort()}
                                onChange={handleSelectedCustomer}
                                sx={{ width: '20%' }}
                                size='small'
                                renderInput={(params) => <TextField {...params} variant="outlined" label={projects.retrieving ? 'loading...' : 'customers'} placeholder="" />}
                            />
                            <Autocomplete
                                multiple
                                disabled={projects.list.length === 0 || selectedCustomer === undefined}
                                limitTags={5}
                                disableCloseOnSelect
                                id="multiple-limit-tags"
                                options={projects.list.filter(p => userMngmt.isAdmin || p.split('/').shift() === userMngmt.customer)}
                                value={selectedProjects}
                                onChange={handleSelectedProject}
                                sx={{ width: '50%' }}
                                size='small'
                                getOptionLabel={(option) => option}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        {option}
                                        {projects.apiProjectMap[option] && (
                                            <Chip label="API" size="small" color="info" sx={{ ml: 1, height: 20, fontSize: '0.7rem' }} />
                                        )}
                                        {(projects.labelsProjectsList || []).includes(option) && (
                                            <Chip label="Labels" size="small" color="secondary" sx={{ ml: 1, height: 20, fontSize: '0.7rem' }} />
                                        )}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" label={projects.retrieving ? 'loading...' : 'project-ids'} placeholder="" />
                                )}
                            />
                        </Stack>

                        <Box sx={{ mt: 3 }}>
                            <Typography variant='h6' sx={{ mb: '0.5em' }}>
                                <b>Attached Users</b>
                            </Typography>
                            {fetchingUsers ? <CircularProgress size={24} /> : (
                                attachedUsers.length > 0 ? (
                                    <TableContainer component={Paper} sx={{ maxWidth: 800 }}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><b>Username</b></TableCell>
                                                    <TableCell><b>Projects</b></TableCell>
                                                    <TableCell><b>Last Login</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {attachedUsers.map(u => (
                                                    <TableRow key={u.email}>
                                                        <TableCell>{u.email}</TableCell>
                                                        <TableCell>{u.projects.join(', ')}</TableCell>
                                                        <TableCell>{u.lastLogin}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    <Typography variant='body2' color='textSecondary'>
                                        {selectedProjects.length === 0 ? 'Select a project to view attached users' : 'No users attached'}
                                    </Typography>
                                )
                            )}
                        </Box>

                        <Stack direction='row' spacing={2} alignItems="center" sx={{ marginTop: '2em' }}>
                            <FormControl size='small' sx={{ minWidth: 140 }}>
                                <Select
                                    value={monthsRange}
                                    onChange={(e) => setMonthsRange(e.target.value)}
                                >
                                    <MenuItem value={12}>Last 12 months</MenuItem>
                                    <MenuItem value={18}>Last 18 months</MenuItem>
                                    <MenuItem value={24}>Last 24 months</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={excludeInternalTest}
                                        onChange={(e) => setExcludeInternalTest(e.target.checked)}
                                        size="small"
                                    />
                                }
                                label="Exclude internal test"
                            />
                            <Button variant='contained' onClick={async () => { await showPlot() }}>
                                show plot
                            </Button>
                            {fetchingData && (<CircularProgress />)}
                        </Stack>
                        <ResponsiveContainer width="100%" height={600}>

                            <BarChart
                                data={plotData}
                                margin={{ top: 40, right: 40, bottom: 40, left: 0, }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="name"
                                    interval={0}
                                    tick={({ x, y, payload }) => {
                                        const [month, year] = payload.value.split(' ');
                                        return (
                                            <text x={x} y={y} textAnchor="middle" fill="#666" fontSize={12}>
                                                <tspan x={x} dy="0.8em">{month}</tspan>
                                                <tspan x={x} dy="1.2em">{year}</tspan>
                                            </text>
                                        );
                                    }}
                                    height={60}
                                />
                                <YAxis />
                                <Tooltip />
                                <Legend />

                                {plotDataBar.map((prj, index) => {
                                    const realId = projects.apiProjectMap[prj] || prj;
                                    const dataKey = realId.split('/')[1] || realId;
                                    return <Bar key={index} dataKey={dataKey} stackId="a" fill={colors[index]} />;
                                })}
                            </BarChart>
                        </ResponsiveContainer>

                        <InfoProjectTable tableData={tableData} />
                    </Item>
                </Grid>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Item key='project-parameters' >
                        <Typography variant='h5' sx={{ marginBottom: '1em' }} >
                            <b>Project Management</b>
                        </Typography>
                        <ProjectDisable auth={auth} projects={projects} />
                    </Item>
                </Grid>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Item key='project-parameters' >
                        <Typography variant='h5' sx={{ marginBottom: '1em' }} >
                            <b>Project Parameters</b>
                        </Typography>
                        <ProjectParameters auth={auth} projects={{...projects, list: projects.list.filter(p => !(projects.labelsProjectsList || []).includes(p))}} />
                    </Item>
                </Grid>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Item key='patch-user' >
                        <Typography variant='h5' sx={{ marginBottom: '1em' }} >
                            <b>Custom Message</b>
                        </Typography>
                        <Stack direction='row' spacing={2} alignItems='flex-start' sx={{ width: '100%' }}>
                            <Autocomplete
                                disabled={projects.list.length === 0}
                                limitTags={1}
                                options={Array.from(new Set(projects.list.map(p => p.split('/').shift()))).sort()}
                                onChange={handleCustomerFilter}
                                defaultValue={undefined}
                                sx={{ width: '13em', minWidth: '13em' }}
                                size='small'
                                renderInput={(params) => <TextField {...params} variant="outlined" label={projects.retrieving ? 'loading...' : 'customers'} placeholder="" />}
                            />
                            <Button
                                disabled={customerFilter.customer === ''}
                                loading={customerFilter.isFetching}
                                variant="contained"
                                onClick={fetchCustomerUsers}
                                sx={{ width: '10em', minWidth: '10em', }}                            >
                                fetch users
                            </Button>


                            <Autocomplete
                                disabled={customerFilter.users.length === 0}
                                limitTags={1}
                                options={customerFilter.users}
                                getOptionLabel={(option) => option.email}
                                isOptionEqualToValue={(option, value) => option.email === value.email}
                                defaultValue={{ email: '' }}
                                value={{ email: patchUsrMngmt.email }}
                                onChange={handleSelectPathEmail}
                                sx={{ width: '30%', minWidth: '15em' }}
                                size='small'
                                renderInput={(params) => <TextField {...params} variant="outlined" label={customerFilter.isFetching ? 'loading...' : 'users'} placeholder="" />}
                            />


                            <TextField
                                disabled={projects.list.length === 0 || patchUsrMngmt.email === ''}
                                id="custom-billing-message"
                                label={'custom message'}
                                value={patchUsrMngmt.customMessage}
                                onChange={handleProjectCustomMessage}
                                sx={{ width: '50%' }}
                                size='small'
                            />
                        </Stack>

                        <Stack direction='row' spacing={2} mt='1em'>
                            <Button
                                disabled={patchUsrMngmt.email === '' || patchUsrMngmt.selectedList.length === 0}
                                loading={patchUsrMngmt.isPatching}
                                loadingPosition="start"
                                variant="contained"
                                onClick={() => patchUserMessage('patch')}
                            >
                                Update Message
                            </Button>
                        </Stack>
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            open={snack.open}
                            autoHideDuration={6000}
                            onClose={handleClose}
                            message={snack.creationMessage}
                            action={
                                <React.Fragment>
                                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>
                            }
                        />
                    </Item>
                </Grid>
            </Grid>
        </div >
    )


    function InfoProjectTable({ tableData }) {
        const [order, setOrder] = useState('Date');
        const [tableDataPrint, setTableDataPrint] = useState(tableData);

        const handleChangeOrder = (event) => {
            setOrder(event.target.value);
            const oderType = event.target.value;
            switch (oderType) {
                case 'Project id':
                    tableDataPrint.sort((a, b) => a.projectId.localeCompare(b.projectId));
                    setTableDataPrint(tableDataPrint);
                    break;
                case 'User':
                    tableDataPrint.sort((a, b) => a.user.localeCompare(b.user));
                    setTableDataPrint(tableDataPrint);
                    break;
                default:
                    tableDataPrint.sort((a, b) => b.dateEpoch - a.dateEpoch);
                    setTableDataPrint(tableDataPrint);
            }
        };
        const columns = [
            /* {
                // width: 100,
                label: 'id',
                dataKey: 'id',
            }, */
            {
                // width: 200,
                label: 'Project id',
                dataKey: 'projectId',
            },
            {
                // width: 120,
                label: 'Date',
                dataKey: 'date',
            },
            {
                // width: 120,
                label: 'User',
                dataKey: 'user',
            },
            {
                // width: 120,
                label: 'Deleted flag',
                dataKey: 'deleted',
            },
            {
                // width: 120,
                label: 'Internal Test flag',
                dataKey: 'internalTest',
            },
        ];

        const VirtuosoTableComponents = {
            Scroller: React.forwardRef((props, ref) => (
                <TableContainer component={Paper} {...props} ref={ref} />
            )),
            Table: (props) => (
                <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
            ),
            TableHead,
            TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
            TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
        };

        function fixedHeaderContent() {
            return (
                <TableRow>
                    {columns.map((column) => (
                        <TableCell
                            key={column.dataKey}
                            variant="head"
                            align={column.numeric || false ? 'right' : 'left'}
                            style={{ width: column.width }}
                            sx={{
                                backgroundColor: 'background.paper',
                            }}
                        >
                            {column.label}
                        </TableCell>
                    ))}
                </TableRow>
            );
        }

        function rowContent(_index, row) {
            return (
                <React.Fragment>
                    {columns.map((column) => (
                        <TableCell
                            key={column.dataKey}
                            align={column.numeric || false ? 'right' : 'left'}
                        >
                            {row[column.dataKey]}
                        </TableCell>
                    ))}
                </React.Fragment>
            );
        }

        function ExportCsv({ csvData, fileName }) {
            const exportToCsv = () => {
                if (!csvData || !csvData.length) return;
                const headers = Object.keys(csvData[0]);
                const csvRows = [
                    headers.join(','),
                    ...csvData.map(row =>
                        headers.map(h => {
                            const val = row[h] == null ? '' : String(row[h]);
                            return val.includes(',') || val.includes('"') || val.includes('\n')
                                ? `"${val.replace(/"/g, '""')}"` : val;
                        }).join(',')
                    )
                ];
                const data = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=UTF-8' });
                FileSaver.saveAs(data, fileName + '.csv');
            }

            return (
                <Button sx={{ marginBottom: '1em' }} variant='contained' onClick={exportToCsv}>CSV Export</Button>
            )
        }

        return (
            (tableDataPrint.length !== 0 &&
                <>
                    <Stack direction='row' spacing={2} justifyContent={'space-between'} alignItems="center">
                        <Typography variant='h5' >
                            <b>Table</b>
                        </Typography>
                        <ExportCsv csvData={tableDataPrint} fileName={selectedCustomer + '_export'} />
                    </Stack>
                    <Stack direction='row' spacing={2} alignItems="center" sx={{ marginBottom: '1em' }}>
                        <Typography >
                            <b>Order by (ascending order):</b>
                        </Typography>
                        <FormControl size='small' sx={{ minWidth: 120, marginBottom: '1em' }}>
                            <Select
                                defaultValue="Date"
                                displayEmpty
                                id="order-select"
                                value={order}
                                onChange={handleChangeOrder}
                            >
                                <MenuItem value="Date">Date</MenuItem>
                                <MenuItem value="Project id">Project id</MenuItem>
                                <MenuItem value="User">User</MenuItem>
                            </Select>
                        </FormControl>
                    </Stack>
                    <Paper style={{ height: 400, width: '100%' }}>
                        <TableVirtuoso
                            data={tableDataPrint}
                            components={VirtuosoTableComponents}
                            fixedHeaderContent={fixedHeaderContent}
                            itemContent={rowContent}
                        />
                    </Paper>
                </>
            )
        )
    }
}